import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

export const formatDate = (dateString: string) => {
  return dayjs(dateString)
    .tz("America/Los_Angeles")
    .format("MMMM D, YYYY h:mm a");
};

export const shortFormatDate = (dateString: string) => {
  return dayjs(dateString).tz("America/Los_Angeles").format("MM/DD/YYYY");
};

export const shortFormatDateTimezoneFree = (dateString: string) => {
  return dayjs(dateString).format("MM/DD/YYYY");
};

// operationalizedDate is a pure calendar date stored at 00:00:00 UTC. Parse it in
// UTC and render date-only so it never shows a spurious time (e.g. "4:00 am") and
// never shifts a day for users in timezones behind UTC.
export const formatOperationalizedDate = (dateString: string) => {
  return dayjs.utc(dateString).format("MMMM D, YYYY");
};

export const shortFormatOperationalizedDate = (dateString: string) => {
  return dayjs.utc(dateString).format("MM/DD/YYYY");
};
